export function isValidPolicyNumber(value: string) {
  return /^[A-Z0-9/\-_ ]+$/i.test(value) && value.length <= 50;
}
